<template>
  <v-content>
    <v-card class="ma-auto mt-10 pb-5" max-width="50rem">
      <v-card class elevation="0">
        <v-card-text>
          <p class="display-1 text--primary">Workspace</p>
          <p class="display-0 text--primary">
            Registration Code: <strong>wsdub+PB2DTX</strong>
          </p>
        </v-card-text>
      </v-card>

      <WorkspaceCard class="mx-auto" />
    </v-card>
  </v-content>
</template>

<script>
import WorkspaceCard from "../components/WorkspaceCard.vue";
export default {
  components: {
    WorkspaceCard,
  },
  name: "Status",
  data() {
    return {};
  },
  async created() {},
  methods: {
    goTo(path) {
      this.$route.path !== path && this.$router.push({ path });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
